import React from 'react';
import PdfUriViewer from '../documentViewers/pdf/PdfUriViewer';
import XmlUriViewer from '../documentViewers/xml/XmlUriViewer';
import FixedFormatUriViewer from '../documentViewers/fixedformat/FixedFormatUriViewer';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import getClientConfig from '../../utils/getClientConfig';
import ReturnPreviewInfo from './ReturnPreviewInfo';

const VIEWER_TYPE = {
  XML: 'XML',
  PDF: 'PDF',
  FIXED_FORMAT: 'FIXED_FORMAT'
};

const XML_PREVIEW_MAX_LINES = 50;

const resolveViewerType = (value) => {
  if (typeof value !== 'string' || value === '') {
    return undefined;
  }
  const normalised = value.trim().toLowerCase();
  if (normalised === 'xml' || normalised === 'text/xml' || normalised === 'application/xml') {
    return VIEWER_TYPE.XML;
  }
  if (normalised === 'pdf' || normalised === 'application/pdf') {
    return VIEWER_TYPE.PDF;
  }
  if (
    normalised === 'fixedformat' ||
    normalised === 'txt' ||
    normalised === 'csv' ||
    normalised === 'json' ||
    normalised === 'text/plain' ||
    normalised === 'text/csv' ||
    normalised === 'application/csv' ||
    normalised === 'application/json'
  ) {
    return VIEWER_TYPE.FIXED_FORMAT;
  }
  return undefined;
};

const ReturnPreview = (props) => {
  const { documentUri, documentType, filename, documentExtension, infoMessageString, languages } = props;
  const XML_PREVIEW_SIZE_LIMIT_BYTES = getClientConfig().xmlAsyncReturnPreviewThreshold;

  if (!documentUri) {
    return null;
  }

  const viewerType = resolveViewerType(documentType);
  const fullFileName = `${filename}.${documentExtension}`;
  const returnRegenerationReminder = infoMessageString ? (
    <ReturnPreviewInfo string={infoMessageString} languages={languages} />
  ) : null;

  if (viewerType === VIEWER_TYPE.XML) {
    return (
      <>
        {returnRegenerationReminder}
        <XmlUriViewer
          uri={documentUri}
          filename={filename}
          fileExtension={documentExtension}
          hideDownload={true}
          maxLines={XML_PREVIEW_MAX_LINES}
          enforceSizeLimit={true}
          sizeLimitBytes={XML_PREVIEW_SIZE_LIMIT_BYTES}
        />
      </>
    );
  }

  if (viewerType === VIEWER_TYPE.PDF) {
    return (
      <>
        {returnRegenerationReminder}
        <PdfUriViewer uri={documentUri} filename={fullFileName} />
      </>
    );
  }

  if (viewerType === VIEWER_TYPE.FIXED_FORMAT) {
    return (
      <>
        {returnRegenerationReminder}
        <FixedFormatUriViewer
          uri={documentUri}
          filename={filename}
          fileExtension={documentExtension}
          hideDownload={true}
        />
      </>
    );
  }

  return (
    <>
      {returnRegenerationReminder}
      <div>
        <LanguageStringResolver string="filingPreviewUnknownType" />: {documentType}
      </div>
    </>
  );
};


ReturnPreview.defaultProps = {
  documentType: '',
  mimeType: '',
  infoMessageString: undefined,
  languages: undefined
};

export default ReturnPreview;
